import {MithrilComponent} from '@bitstillery/mithril'
import m from '@bitstillery/mithril'
import {CollectionProxy} from '@bitstillery/common/lib/collection'
import type {GetPortalOfferItemResponse} from '@bitstillery/common/api/fact2server'
import {$t, api, notifier} from '@bitstillery/common/app'
import {CollectionCarousel} from '@bitstillery/common/components/portal'
import {PlausibleCartSource} from '@bitstillery/common/lib/utils'

import {$s} from '@/app'
import {load_product_photos} from '@/models/offer'
import {CollectionProduct} from '@/components/collection/product'

export const collection = new CollectionProxy<GetPortalOfferItemResponse>()

export class CollectionRecommendations extends MithrilComponent {
    override async oninit() {
        // Recommendations are per order; before the order is established there is nothing to ask for.
        const order_artkey = $s.cart.artkey
        if (!order_artkey) {
            return
        }
        const data = {
            offset: collection.state.items.length,
            page_size: 18,
            sort_ascending: true,
            sort_by: 'artkey',
        }
        const {result, success} = await api.get(`portal/orders/${order_artkey}/recommendations/collection-view`, data)
        if (!success) {
            notifier.notify('Cannot load the recommendations', 'warning')
            return
        }
        collection.state.items.splice(0, collection.state.items.length, ...result)
        const artkeys_to_fetch = collection.state.items.map((i) => i.artkey)
        await load_product_photos(artkeys_to_fetch)
    }

    view(_vnode: m.Vnode) {
        return (
            <CollectionCarousel
                collection={collection}
                icon='offers'
                item={(cart_item, opts) => (
                    <CollectionProduct
                        collection={collection}
                        global_index={opts.global_index}
                        key={cart_item.case_artkey}
                        offer_item={cart_item}
                        source={PlausibleCartSource.RECOMMENDATIONS}
                        variant='cart'
                        virtualize={false}
                    />
                )}
                title={$t('cart.recommendations_title')}
            />
        )
    }
}
